import { z } from 'zod';

import { declarationViewDV1Schema } from '../DeclarationViewDV1';

export const declarationStakeholdersSchema = z.object({
  stakeholders: z.object({
    exporter: z.object({
      header: z.boolean().optional().nullable(),
      name: z.string().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      address: z.object({
        country: z.string().optional().nullable(),
        street: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
      }),
    }),
    importer: z.object({
      name: z.string().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      address: z.object({
        street: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
    }),
    consignee: z.object({
      name: z.string().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      address: z.object({
        street: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
    }),
    declarant: z.object({
      name: z.string().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      address: z.object({
        street: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
      contactPerson: z.object({
        name: z.string().optional().nullable(),
        phoneNumber: z.string().optional().nullable(),
        email: z.string().optional().nullable(),
      }),
    }),
    intracom: z.object({
      name: z.string().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      address: z.object({
        street: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
    }),
    additionalSupplyChainActor: z.object({
      header: z.boolean().optional().nullable(),
      name: z.string().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      role: z.string().optional().nullable(),
      address: z.object({
        street: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
    }),
  }),
  dv1: z.object({
    seller: z.object({
      header: z.boolean().optional().nullable(),
      name: z.string().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      address: z.object({
        street: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
    }),
    buyer: z.object({
      header: z.boolean().optional().nullable(),
      identificationNumber: z.string().optional().nullable(),
      name: z.string().optional().nullable(),
      address: z.object({
        street: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
    }),
  }),
});

const mergedSchema = z.intersection(declarationStakeholdersSchema, declarationViewDV1Schema);
export type mergedType = z.infer<typeof mergedSchema>;

export type DeclarationStakeholdersFormValues = z.infer<typeof declarationStakeholdersSchema>;
